'use client';

import { parseUserAgent } from '@diritto/common/utils/userAgent';
import { useInAppState } from '@/contexts/InAppProvider';
import { SearchPage } from 'app/(main)/search/SearchPage';

export default function Page() {
  const { userAgent } = useInAppState();
  const { isApp } = parseUserAgent(userAgent ?? '');
  return (
    <>
      <title>검색 | 디리토</title>
      <SearchPage isApp={isApp} />
    </>
  );
}
